(function () {
    var RCDPW = this.RCDPW;
    RCDPW.moduleNames = {
        MY_ACCOUNT: 'myAccountApp',
        ANNOUNCEMENTS: 'announcementsApp',
        SUPPORT: 'supportApp',
        SUPPORT_CREATE_CASE: 'supportCreateCaseApp',
        BLOG: 'blogApp',
        BLOG_POST: 'blogPostApp',
        HOME_PAGE: 'homePage',
        ADMIN: 'administration',
        JS_SDK_GUIDE: 'jsSDKGuideApp',
        API_EXPLORER: 'apiExplorerApp',
        SWAGGER_UI_API_EXPLORER: 'swaggerUiApiExplorer',
        OVERVIEW: 'overview',
        APP_GALLERY: 'appGallery',
        LOGIN_AS_ADMIN: 'loginAsAdmin',
        FREE_EXTENSION_SIGN_UP: 'freeExtensionSignUp',
        THREE_LEGGED_LOGIN: 'threeLeggedLogin',
        HOME: 'home',
        NOT_FOUND: 'notFound', //404
        API_AND_DOCS: 'apiAndDocs',
        API_PRODUCTS: 'apiProducts',
        EMBEDDABLE_VOICE: 'embeddableVoice',
        SERVICES: 'servicesApp',
        DEVELOPER_EVENTS: 'developerEvents',
        GETTING_STARTED: 'gettingStarted',
        COMMUNITY: 'community',
        GO_TO_COMMUNITY: 'goToCommunity',
        GO_TO_COMMUNITY_EXT: 'goToCommunityExt'
    };

    init();

    // Call before document ready
    function init() {
        initConfig();
        setupGlobalAsyncRequestOptions();
        RCDPW.validator.setup();
    }

    // Call after document ready
    RCDPW.bootstrap = function (config) {
        config = config || {};
        customFormElements();
        RCDPW.pageName = config.pageName;
    };

    function initConfig() {
        RCDPW.isLogin = ($.cookie('IS_LOGIN') != undefined);
        $.ajaxSetup({ cache: false });

        // Register an handler which is called an Ajax request is sent.
        $(document).ajaxSend(function (event, xhr) {
            xhr.setRequestHeader('X-XSRF-TOKEN', $.cookie('XSRF-TOKEN'));
        });
    }

    // Ajax Request Interceptors
    function setupGlobalAsyncRequestOptions() {
        RCDPW.loadingCount = 0;

        $(document).ajaxStart(function onRequestStart() {
            var preloader = $('#preloader');
            preloader.show();
            setTimeout(function () {
                preloader.addClass('active');
            }, 1);
            RCDPW.loadingCount++;
            preloader.find('.preloader-loading-loader').attr('id', 'x-loader');
        });
        $(document).ajaxStop(function onRequestStop() {
            var preloader = $('#preloader');
            RCDPW.loadingCount--;
            if (RCDPW.loadingCount == 0) {
                preloader.hide();
                preloader.removeClass('active');
                preloader.find('.preloader-loading-loader').attr('id', '');
            }
        });
    }

    function customFormElements() {
        //todo remove formSelect relevant things
        $('.formSelect').each(function (idx, item) {
            item = $(item);
            handleSelect(item);
            item.on('change', function () {
                handleSelect($(this));
            });
        });

        function handleSelect(item) {
            item.find('span').text(item.find('select').val());
        }

        handlePlaceHolder();

        //handle placeholder
        function handlePlaceHolder() {
            if (!hasPlaceHolderElements() || supportNative()) {
                return;
            }
            $(':text[placeholder]').each(handler);
            $(':password[placeholder]').each(handler);
            $('textarea[placeholder]').each(handler);

            function handler() {

                var $element = $(this);
                var $container = $element.closest('.inputTextContainer');
                if ($.isEmptyObject($container)) {
                    return;
                }
                $container.addClass('emptyTextActive');
                var $emptyTextDom = $('<div></div>');
                $emptyTextDom.addClass('emptyText');
                $emptyTextDom.html($element.attr('placeholder'));
                $container.append($emptyTextDom);
                $element.on('focus', function () {
                    $container.removeClass('emptyTextActive');
                });
                $element.on('blur', function () {
                    ($element.val().length == 0) && $container.addClass('emptyTextActive');
                })
            }

            function hasPlaceHolderElements() {
                return ($(':text[placeholder]').length + $('textarea[placeholder]').length) > 0;
            }

            function supportNative() {
                return document.createElement("input").placeholder !== void 0;
            }
        }
    }

    /**
     * angular common modules and utils
     * todo refactor
     */
    (function () {
        var appName = '';
        var modules = ['dpw.common'];

        RCDPW.Angular = {
            setAppName: function (name) {
                appName = name;
            },
            bootstrap: function () {
                angular.bootstrap(document, modules, { strictDi: true });
                ensureBootstrap();

                // It seems only Google Chrome without cache disabled doesn't bootstrap sometimes
                // Exclude the scenario that bootstrap was deferred (Protractor will defer the bootstrap process).
                function ensureBootstrap() {
                    var isBootstrapDeferred = _.isFunction(angular.resumeBootstrap);

                    if (isBootstrapDeferred) {
                        return;
                    }

                    setTimeout(function () {
                        var notBootstrapped = $(document).injector() == null;
                        if (notBootstrapped) {
                            RCDPW.console.log('checkBootstrap: reBootstrap');
                            angular.bootstrap(document, modules);
                            ensureBootstrap();
                        }
                    }, 200);
                }
            },
            buildModule: function (moduleName) {
                var name = [appName, moduleName].join('.');
                modules.push(name);
                return angular.module(name, ['dpw.common']);
            },
            config: function (configObj) {
                angular.module('dpw.common').config(configObj);
            }
        };

        RCDPW.SEO = {
            addCanonical: function (link) {
                $("head").append('<link rel="canonical" href="https://developers.ringcentral.com' + link + '"/>');
            },

            addAlternate: function (link) {
                $("head").append('<link rel="alternate"  media="only screen and (max-width: 640px)" href="' + link + '"/>');
            },
            updateMetaDesc: function (description) {
                var seoService = angular.injector(['ng', 'dpw.services']).get("seoService");
                seoService.updateDescription(description, seoService.from.pageSpecific);
            }
        };

        angular.module('dpw.directives')
            .directive('dpwMain', [
                'dpwEvents', '$sce', 'helpers', 'trackUtil',
                function (dpwEvents, $sce, helpers, trackUtil) {
                    return {
                        restrict: 'A',
                        controller: ['$scope', 'mixpanelService', '$window', function ($scope, mixpanelService, $window) { //used for sharing data
                            var self = this;
                            $scope.isLogin = RCDPW.isLogin;
                            $scope.siteWideTexts = RCDPW.Lang.Contentful.SiteWide;
                            self.nowObj = new Date(); //used for footer copyright for now
                            self.isAdminSite = RCDPW.isAdminSite;
                            self.legalUrl = RCDPW.legalUrl;
                            self.getGoToCommunityUrl = helpers.getGoToCommunityUrl;
                            self.blogUrl = RCDPW.blogUrl;
                            self.setPageBackButton = function (value, onClick) {
                                $scope.showPageBackButton = value;
                                angular.isFunction(onClick) && ($scope.onPageBackButtonClick = onClick);
                            };
                            self.setPageTitle = function (value) {
                                $scope.pageTitle = value;
                            };

                            if (!helpers.isApiRef()) {
                                trackUtil.logPageView(RCDPW.pageName);

                                if (!RCDPW.isAdminSite && RCDPW.pageName) {
                                    mixpanelService.trackPageView(RCDPW.pageName);
                                }
                            }


                            self.apiRefCommunicator = {
                                eventBanner: {
                                    height: 0,
                                    browserEventDispatcher: $window,
                                    onServiceReady: function () {
                                        var eventBannerCommunicator = this;
                                        var browserEventName = 'ApiRef.EventBannerService.Ready';
                                        this.browserEventDispatcher.addEventListener(browserEventName, function () {
                                            setTimeout(function () {
                                                eventBannerCommunicator.emitHeight(eventBannerCommunicator.height);
                                            }, 300);
                                        });
                                    },
                                    emitHeight: function (height) {
                                        var browserEventName = 'DPW.EventBanner.HeightChange';

                                        var event = new Event(browserEventName);
                                        event.eventBannerHeight = height;

                                        this.browserEventDispatcher.dispatchEvent(event);
                                        this.height = height;
                                    }
                                }
                            };

                            self.apiRefCommunicator.eventBanner.onServiceReady();

                            checkAccessPermission();

                            function checkAccessPermission() {
                                var forbiddenConfigs = RCDPW.forbiddenConfigs;
                                var currentLoginStatus = RCDPW.isLogin ? 'login' : 'logout';
                                var forbiddenConfig = forbiddenConfigs[currentLoginStatus];
                                _.forEach(forbiddenConfig.urls, function (url) {
                                    if (url.href === window.location.pathname) {
                                        window.location.href = url.redirectTo;
                                        return false;
                                    }
                                });
                            }
                        }],
                        controllerAs: 'main'
                    };
                }]
            ).directive('dpwAddSpace', [function () { //used for text-align justified, compatible with IE8, but be careful when using html minimization
                return {
                    restrict: 'A',
                    link: function (scope, element) {
                        (!scope.$last) && element.after(' ');
                    }
                };
            }]
            ).directive('dpwPlaceHolder', [function () { //refactor
                return {
                    restrict: 'A',
                    link: function (scope, element, attrs) {
                        (!supportNative()) && handler();

                        function supportNative() {
                            return document.createElement("input").placeholder !== void 0;
                        }

                        function handler() {

                            var $element = element;
                            var $container = $element.closest('.inputTextContainer');
                            if ($.isEmptyObject($container)) {
                                return;
                            }
                            scope.$watch(attrs.ngModel, function (val) {
                                val && $container.removeClass('emptyTextActive');
                            });
                            ($element.val().length == 0) && $container.addClass('emptyTextActive');
                            var $emptyTextDom = $('<div></div>');
                            $emptyTextDom.addClass('emptyText');
                            $emptyTextDom.html($element.attr('placeholder'));
                            $container.append($emptyTextDom);
                            $element.on('focus', function () {
                                $container.removeClass('emptyTextActive');
                            });
                            $element.on('blur', function () {
                                ($element.val().length == 0) && $container.addClass('emptyTextActive');
                            });
                        }
                    }
                };
            }]
            ).directive('dpwAddSpaceAll', [function () { //used for text-align justified, compatible with IE8, but be careful when using html minimization
                return {
                    restrict: 'A',
                    link: function (scope, element, attrs) {
                        if ($('html').hasClass('lt-ie9') && attrs.hasOwnProperty('addSpaceExceptIe8')) {
                            // ie8 with addSpaceExceptIe8 specified, addspace not work with ng-repeat in ie8 when removing items.
                            return;
                        } else {
                            element.after(' ');
                        }
                    }
                };
            }]
            ).directive('dpwPagePath', [function () { //used for text-align justified, compatible with IE8, but be careful when using html minimization
                return {
                    restrict: 'A',
                    scope: {
                        path: '@'
                    },
                    controller: ['$scope', function ($scope) {
                        var path = $scope.path || '';
                        path = (path != '' ? ['index', path].join(',') : 'index');
                        var pathArr = path.split(',');
                        $scope.items = [];
                        angular.forEach(pathArr, function (pathItem) {
                            $scope.items.push(RCDPW.entries[pathItem]);
                        });
                    }],
                    templateUrl: 'dpw-page-path.html'
                };
            }]
            ).directive('dpwPagination', ['$filter', function ($filter) {
                return {
                    restrict: 'A',
                    scope: {
                        paging: '='
                    },
                    controller: ['$scope', function ($scope) {
                        this.first = function () {
                            $scope.paging.page = 1;
                        };
                        this.last = function () {
                            $scope.paging.page = $scope.paging.totalPages;
                        };
                        this.next = function () {
                            ($scope.paging.page < $scope.paging.totalPages) && $scope.paging.page++;
                        };
                        this.prev = function () {
                            ($scope.paging.page > 1) && $scope.paging.page--;
                        };
                        this.isFirst = function () {
                            return angular.isObject($scope.paging) ? $scope.paging.page == 1 : false;
                        };
                        this.isLast = function () {
                            return angular.isObject($scope.paging) ? ($scope.paging.page == $scope.paging.totalPages) : false;
                        };
                    }],
                    controllerAs: 'ctrl',
                    templateUrl: 'dpw-pagination.html'
                };
            }]
            ).directive('rcdpwRequestInvitation', [function () {
                return {
                    restrict: 'C',
                    link: function (scope, element) {
                        var path = window.location.pathname;
                        var isRequestPage = (path == RCDPW.entries.reqInv.href);
                        isRequestPage && element.addClass('x-hidden');
                    }
                };
            }]
            ).directive('dpwEditOrgNamePopup', [function () {
                return {
                    restrict: 'A',
                    scope: true,
                    controller: ['$scope', '$element', '$attrs', function ($scope, $element, $attrs) {
                    }],
                    controllerAs: 'ctrl',
                    link: function (scope, element) {
                        scope.ctrl.submit = function () {
                            if (element.find('form').valid()) {
                                scope.callback();
                            }
                        }
                    },
                    templateUrl: 'dpw-edit-org-name-popup.html'
                };
            }]
            ).directive('dpwAppKeySecret', [function () {
                return {
                    restrict: 'A',
                    scope: {
                        key: '=',
                        isSampleApp: '='
                    },
                    controller: ['$scope', '$element', 'api', function ($scope, $element, api) {
                        $scope.$watch('key.id', function (newValue, oldValue) {
                            _.isObject($scope.key) && ($scope.key.isMasked = true);
                        });
                        var el = $element.find('.appkey-secret');
                        this.click = function () {
                            if (!RCDPW.isAdminSite && $scope.isSampleApp) {
                                api.call(api.myAccount.applications.getSampleAppSecret({
                                    noLoading: true
                                }), function (data) {
                                    $scope.key.secret = data.value;
                                    $scope.key.isMasked = false;
                                    setTimeout(function () {
                                        el.attr('title', '');
                                        if (el[0].scrollWidth > el.outerWidth()) {
                                            el.attr('title', el.text());
                                        }
                                    }, 1);
                                });

                                return;
                            }

                            api.call(api.getSecret({
                                id: $scope.key.id
                            }), function (data) {
                                $scope.key.secret = data.appKey.secret;
                                $scope.key.isMasked = false;
                                setTimeout(function () {
                                    el.attr('title', '');
                                    if (el[0].scrollWidth > el.outerWidth()) {
                                        el.attr('title', el.text());
                                    }
                                }, 1);
                            });
                        };
                    }],
                    controllerAs: 'ctrl',
                    templateUrl: 'dpw-appKey-secret.html'
                };
            }]
            ).directive('dpwJqValidate', [function () {
                return {
                    restrict: 'A',
                    scope: {
                        disabled: '=validateDisabled',
                        rule: '@',
                        noAutoScroll: '@'
                    },
                    link: function (scope, element) {
                        var options = {
                            rules: eval('RCDPW.validator.rules.' + scope.rule)
                        };
                        var validator;
                        var defaultValidateIgnore;

                        scope.$watch('disabled', function () {
                            validator.settings.ignore = scope.disabled === true ? '*' : defaultValidateIgnore;
                        });

                        if (scope.noAutoScroll) {
                            options.invalidHandler = function () {

                            };
                        }

                        validator = element.validate(options);
                        defaultValidateIgnore = validator.settings.ignore;
                    }
                };
            }]
            ).directive('submitOnEnter', [function () {
                return {
                    restrict: 'A',
                    link: function (scope, element) {
                        element.find('input').on('keypress', function (e) {
                            if (e.which == 13) {
                                element.find('.fieldSubmit').click();
                            }
                        });
                    }
                };
            }]
            ).directive('dpwThSort', ['$compile', function ($compile) {
                return {
                    restrict: 'A',
                    scope: {
                        dpwThSort: '=',
                        dpwSortHandler: '&',
                        dpwSortCompact: '@'
                    },
                    link: function (scope, element) {
                        var dom = $compile('<div dpw-sort-arrows class="dpw-sort-arrows-container"/>')(scope);
                        element.append(dom);
                    }
                };
            }]
            ).directive('dpwAlertBox', [function () {
                return {
                    restrict: 'A',
                    scope: {},
                    transclude: true,
                    controller: ['$scope', '$element', function ($scope, $element) {
                        var self = this;
                        self.close = function () {
                            $scope.$on('$destroy', function () {
                                $element.remove();
                            });
                            $scope.$destroy();
                        }
                    }],
                    controllerAs: 'ctrl',
                    templateUrl: 'dpw-alert-box.html'
                };
            }]
            ).directive('historyFormatter', ['$compile', 'helpers', 'historyFieldMap', '$filter', 'appBrandsService', 'keyStatusAlias',
                'allAppState', function ($compile, helpers, historyFieldMap, $filter, appBrandsService, keyStatusAlias, allAppState) {
                    return {
                        restrict: 'A',
                        scope: {
                            historyData: '=',
                            colType: '@',
                            mappingObjects: '=',
                            historyType: '='
                        },
                        link: function (scope, element) {
                            var newScope = scope.$new();
                            appBrandsService.init().then(function () {
                                element.append($compile(buildContent())(newScope));
                            });


                            function buildContent() {
                                var emptyString = '&mdash;';
                                var colType = scope.colType;
                                var historyType = scope.historyType;
                                var historyData = scope.historyData || {};
                                var mappingObjects = scope.mappingObjects;
                                var objects = historyData.objects || {};
                                var eventType = historyData.eventType;
                                var dataObjType = _.get(historyData, 'target.type');
                                var changes = _.get(historyData, 'details.changedFields', []);
                                var changesMap = function () {
                                    var map = {};
                                    _.forEach(changes, function (item) {
                                        map[item.fieldName] = item;
                                    });
                                    return map;
                                }();
                                var handlers = {
                                    'sandbox-account': handleSandbox,
                                    'default-parameter': handleParameter,
                                    'organization-parameter': handleParameter,
                                    'application-parameter': handleParameter,
                                    'application-attribute': handleAppAttribute,
                                    'app-profile': handleAppProfile,
                                    'app-profile-revision': handleAppProfile,
                                    'key': handleKey,
                                    'application-state': handleAppState
                                };
                                return (handlers[dataObjType] || handleCommon)();

                                function handleUsagePlan(value) {
                                    var usagePlanId = value || {};
                                    var usagePlans = mappingObjects.usagePlans || [];
                                    var planName = _.get(_.find(usagePlans, { id: usagePlanId }), 'name', emptyString);
                                    return '<a href="' + RCDPW.entries.administration.href + '#/usage-plans/' + usagePlanId + '">' + _.escape(planName) + '</a>';
                                }

                                function handleCommon(options) {
                                    options = options || {};
                                    var retValConfig = {
                                        'ADD': handleAddDeleteType,
                                        'DELETE': handleAddDeleteType,
                                        'UPDATE': handleUpdate
                                    };
                                    return retValConfig[eventType]();

                                    function handleUpdate() {
                                        return _.map(changes, function (change) {
                                            return wrapper(parseValue(change, options) || emptyString);
                                        }).join('');
                                    }

                                    function handleAddDeleteType() {
                                        var retValConfig = {
                                            'fieldName': options.fieldPrefix || getFormattedObjectType(),
                                            'oldValue': emptyString,
                                            'newValue': eventType == 'ADD' ? 'Created' : 'Deleted'
                                        };
                                        return wrapper(retValConfig[colType]);
                                    }

                                    function parseValue(change, options) {
                                        var fieldPrefix = options.fieldPrefix || '';
                                        var changedField = change.fieldName;
                                        var value = change[colType] || '';
                                        var retValConfig = {
                                            'fieldName': handleField,
                                            'oldValue': handleOldNewValue,
                                            'newValue': handleOldNewValue
                                        };
                                        return retValConfig[colType]();

                                        function handleField() {
                                            var fieldName = historyFieldMap[dataObjType] && historyFieldMap[dataObjType][changedField];
                                            fieldName = fieldName || _.capitalize((_.startCase(value).toLowerCase()));
                                            return fieldPrefix ? [fieldPrefix, fieldName].join(': ') : fieldName;
                                        }

                                        function handleOldNewValue() {
                                            var retValueConfig = {
                                                'permissions': handlePermGrant,
                                                'grantTypes': handlePermGrant,
                                                'secret': handleSecret,
                                                'type': handlePlatformType,
                                                'expirationTime': handleTime,
                                                'brands': handleBrands,
                                                'apiPlanId': function () {
                                                    return handleUsagePlan(value);
                                                },
                                                'status': handleStatus
                                            };
                                            if (dataObjType === "organization" && changedField === "type") {
                                                return rawValue();
                                            }
                                            return (retValueConfig[changedField] || rawValue)();

                                            function handlePermGrant() {
                                                if (!value) {
                                                    return emptyString;
                                                }
                                                if (dataObjType === 'dev-app-permissions') {
                                                    return rawValue();
                                                }
                                                if (scope.mappingObjects == null) {
                                                    return emptyString;
                                                }
                                                return _.map(value.split(','), function (item) {
                                                    var mapItem = _.get(mappingObjects, changedField + '.' + item, {});
                                                    return $filter('grantType')(mapItem.name);
                                                }).join(', ');
                                            }

                                            function handleSecret() {
                                                if (!value) {
                                                    return emptyString;
                                                }
                                                newScope.appKey = {
                                                    secret: value
                                                };
                                                return '<div dpw-app-key-secret key="appKey"></div>';
                                            }

                                            function handlePlatformType() {
                                                return helpers.getPlatformTypeTextById(value);
                                            }

                                            function handleTime() {
                                                if (!value) {
                                                    return emptyString;
                                                }
                                                return $filter('consoleDateTime')(value);
                                            }

                                            function handleBrands() {
                                                if (!value) {
                                                    return emptyString;
                                                }

                                                var nameMap = appBrandsService.getBrandNameMap();
                                                return _.map(value.split(','), function (brandId) {
                                                    return nameMap[brandId] || '';
                                                }).join(', ');
                                            }

                                            function handleStatus() {
                                                if (!value) {
                                                    return emptyString;
                                                }
                                                return keyStatusAlias[value] || value;
                                            }

                                            function rawValue() {
                                                return _.escape(value);
                                            }
                                        }
                                    }
                                }

                                function handleAppAttribute() {
                                    var change = _.first(changes) || {};
                                    var object = _.find(objects, { type: dataObjType }) || {};
                                    var prefix = historyFieldMap[object.type] || '';
                                    var retValConfig = {
                                        'fieldName': function () {
                                            return prefix + ':<br/>' + object.displayName;
                                        },
                                        'oldValue': function () {
                                            return formatValue(change.oldValue, emptyString);
                                        },
                                        'newValue': function () {
                                            return formatValue(change.newValue, emptyString);
                                        }
                                    };

                                    function formatValue(value, emptyValue) {
                                        return _.escape(value) || emptyValue;
                                    }

                                    return wrapper(retValConfig[colType]());

                                }

                                function handleKey() {
                                    var change = _.first(changes) || {};
                                    var object = _.find(objects, { type: dataObjType }) || {};
                                    var prefix = historyFieldMap[object.type] || '';
                                    var retValConfig = {
                                        'fieldName': function () {
                                            return prefix + ' Status';
                                        },
                                        'oldValue': function () {
                                            return formatValue(change.oldValue, emptyString);
                                        },
                                        'newValue': function () {
                                            return formatValue(change.newValue, emptyString);
                                        }
                                    };

                                    function formatValue(value, emptyValue) {
                                        return value || emptyValue;
                                    }

                                    function getIsProdFlag() {
                                        var obj = _.find(changes, { fieldName: 'isProduction' });
                                        return _.get(obj, 'newValue') === 'true' || _.get(obj, 'oldValue') === 'true';
                                    }

                                    if (_.includes(['ADD', 'DELETE'], eventType)) {
                                        if (historyType !== 'key') {
                                            prefix = (getIsProdFlag() ? 'Production' : 'Sandbox') + ' ' + prefix;
                                        }
                                        return handleCommon({
                                            fieldPrefix: prefix
                                        });
                                    }
                                    return wrapper(retValConfig[colType]());
                                }

                                function handleAppProfile() {
                                    var change = _.first(changes) || {};
                                    var retValConfig = {
                                        'fieldName': function () {
                                            return historyFieldMap[dataObjType] + ' status';
                                        },
                                        'oldValue': function () {
                                            return emptyString;
                                        },
                                        'newValue': function () {
                                            return formatValue(change.newValue, emptyString);
                                        }
                                    };

                                    function formatValue(value, emptyValue) {
                                        return value || emptyValue;
                                    }

                                    return wrapper(retValConfig[colType]());
                                }

                                function handleParameter() {
                                    var change = _.first(changes) || {};
                                    var object = _.find(objects, { type: dataObjType }) || {};
                                    var retValConfig = {
                                        'fieldName': function () {
                                            return historyFieldMap[object.type] + ': <br>' + object.displayName;
                                        },
                                        'oldValue': function () {
                                            return formatValue(change.oldValue, emptyString);
                                        },
                                        'newValue': function () {
                                            return formatValue(change.newValue, 'Deleted');
                                        }
                                    };

                                    function formatValue(value, emptyValue) {
                                        value = object.displayName === 'DefaultApiPlan' ? handleUsagePlan(value) : _.escape(value);
                                        return value || emptyValue;
                                    }

                                    return wrapper(retValConfig[colType]());
                                }

                                function handleSandbox() {
                                    var retValConfig = {
                                        'fieldName': getFormattedObjectType,
                                        'oldValue': getEmptyString,
                                        'newValue': function () {
                                            var eventTypeConifg = {
                                                'ADD': function () {
                                                    return 'In progress';
                                                },
                                                'UPDATE': function () {
                                                    var updateResultConfig = {
                                                        'Success': 'Created: ' + _.get(changesMap, 'phoneNumber.newValue', ''),
                                                        'Failed': 'Created failed'
                                                    };
                                                    var status = changesMap.status || {};
                                                    return updateResultConfig[status.newValue] || emptyString;
                                                },
                                                'DELETE': function () {
                                                    return [
                                                        'Deleted',
                                                        _.get(changesMap, 'phoneNumber.oldValue', '')
                                                    ].join(': ');
                                                }
                                            };

                                            return (eventTypeConifg[eventType] || getEmptyString)();
                                        }
                                    };
                                    return wrapper(retValConfig[colType]());
                                }

                                function handleAppState() {
                                    var status = changesMap.status || {};
                                    var retValConfig = {
                                        'fieldName': getFormattedObjectType(),
                                        'oldValue': emptyString,
                                        'newValue': getAppStateDisplayName(status.newValue) || emptyString
                                    };
                                    return wrapper(retValConfig[colType]);
                                }

                                function getAppStateDisplayName(appState) {
                                    var appStateObj = _.find(allAppState, { id: appState }) || {};
                                    return appStateObj.name;
                                }

                                function getFormattedObjectType() {
                                    if (dataObjType === 'key') {
                                        return 'Application Key';
                                    }
                                    return _.capitalize((_.startCase(dataObjType).toLowerCase()));
                                }

                                function wrapper(value) {
                                    value = value || '';
                                    return ['<div class="history-change-item dpw-add-title">', value, '</div>'].join('');
                                }

                                function getEmptyString() {
                                    return emptyString;
                                }
                            }
                        },
                        controllerAs: 'ctrl'
                    };
                }]
            ).directive('dpwSortArrows', [function () {
                return {
                    restrict: 'A',
                    controller: ['$scope', function ($scope) {
                        var sortTypeMap = {
                            'asc': true,
                            'desc': false
                        };
                        var self = this;

                        self.compact = $scope.hasOwnProperty('dpwSortCompact');
                        this.sort = function (sortType) {
                            var isAsc = sortTypeMap[sortType];
                            if (isAsc === $scope.dpwThSort) {
                                return;
                            }
                            $scope.dpwSortHandler({ isAsc: isAsc });
                        };
                    }],
                    controllerAs: 'ctrl',
                    templateUrl: 'dpw-sort-arrows.html'
                };
            }]
            ).directive('dpwCollapsibleBox', [function () {
                return {
                    restrict: 'A',
                    transclude: true,
                    scope: {
                        titleText: '@'
                    },
                    controller: ['$scope', function ($scope) {
                        var self = this;
                        self.isCollapsed = true;
                        self.title = $scope.titleText;
                    }],
                    controllerAs: 'ctrl',
                    templateUrl: 'dpw-collapsible-box.html'
                };
            }]
            ).directive('dpwCopyPopup', [function () {
                return {
                    restrict: 'A',
                    scope: true,
                    controller: ['$scope', function ($scope) {
                        var self = this;
                        self.text = $scope.text;
                        self.desc = $scope.desc;
                        self.ok = function () {
                            $scope.callback();
                        };
                    }],
                    link: function (scope) {
                        scope.$watch('text', function (val) {
                            if (val) {
                                var input = document.getElementById('dpw-copy-popup-text');

                                document.getElementById('dpw-copy-popup-text').select();
                            }
                        })
                    },
                    controllerAs: 'ctrl',
                    templateUrl: 'dpw-copy-popup.html'
                };
            }]
            ).directive('dpwCollapsibleSection', [function () {
                return {
                    restrict: 'A',
                    scope: {
                        forDomId: '@',
                        titleText: '@',
                        linkText: '@',
                        clickHandler: '&'
                    },
                    controller: ['$scope', function ($scope) {
                        var self = this;
                        self.isCollapsed = true;
                        self.linkText = $scope.linkText;
                        self.titleText = $scope.titleText;
                        self.clickHandler = function () {
                            self.isCollapsed = !self.isCollapsed;
                            $scope.clickHandler();
                        };
                    }],
                    link: function (scope) {
                        scope.$watch('ctrl.isCollapsed', function (value) {
                            var forDom = $('#' + scope.forDomId);
                            value ? forDom.hide() : forDom.show();
                        });
                    },
                    controllerAs: 'ctrl',
                    templateUrl: 'dpw-collapsible-section.html'
                };
            }]
            ).directive('dpwAddTitle', ['$timeout', function ($timeout) {
                return {
                    restrict: 'AC',
                    link: function (scope, element) {
                        element.addClass('ellipsis');
                        scope.$watch(updateTitle);

                        function updateTitle() {
                            element.attr('title', '');
                            if (element[0].scrollWidth > element.outerWidth()) {
                                element.attr('title', element.text());
                            }
                        }
                    }
                };
            }]
            );

        angular.module('dpw.components').component('dpwAppGalleryLink', {
            templateUrl: 'dpw-app-gallery-link.html',
            controller: ['profileBrandsUtils', function (profileBrandsUtils) {
                var $ctrl = this;

                $ctrl.$onChanges = function (changes) {
                    if (changes.brandId && $ctrl.brandId) {
                        $ctrl.appGalleryLink = buildApwUrl();
                    }
                };
                $ctrl.appGalleryDisplayName = $ctrl.displayName || RCDPW.Lang.APP_GALLERY_DISPLAY_NAME;
                $ctrl.target = '_blank';

                function buildApwUrl() {
                    var apwUrl = RCDPW.Lang.APP_GALLERY_URL;
                    var brand = profileBrandsUtils.getBrandById($ctrl.brandId);
                    if (brand && brand.slug) {
                        apwUrl = apwUrl + brand.slug + '/';
                    }
                    return apwUrl;
                }
            }],
            bindings: {
                displayName: '@',
                brandId: '<'
            }
        });


        angular.module('dpw.common').config(['tmhDynamicLocaleProvider', '$httpProvider',
            function (tmhDynamicLocaleProvider, $httpProvider) {


                tmhDynamicLocaleProvider.localeLocationPattern('/assets/vendor/angular-i18n/angular-locale_{{locale}}.js?v=' + RCDPW.version);
                tmhDynamicLocaleProvider.defaultLocale('en-us');

                $httpProvider.useApplyAsync(true);
                $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

                $httpProvider.interceptors.push(['$timeout', 'helpers', 'preLoader', function ($timeout, helpers, preLoader) {
                    return {
                        'request': function (config) {
                            isShowLoading(config) && preLoader.show();
                            return config;
                        },
                        'response': function (response) {
                            isShowLoading(response.config) && preLoader.hide();
                            return response;
                        },
                        'responseError': function (response) {
                            isShowLoading(response.config) && preLoader.hide();
                            return response;
                        }
                    };

                    function isShowLoading(config) {
                        var url = _.get(config, 'url', '');
                        return (config.noLoading !== true) && helpers.isAPICall(url);
                    }
                }]);

            }]).run(RCDPW.runConfig);
    })();
})();
